import React from 'react';
import { H5 } from '../../../AbstractElements';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { radialChartLive } from '../../../Data/Widgets/Chart/ChartData';
import { SkillStatus } from '../../../Constant';
import { FiTrendingUp } from 'react-icons/fi';

const SkillStatusChart = () => {
  return (
    <>
      <Col xl='4' lg='12' className='box-col-6 xl-50'>
        <Card>
          <CardHeader className='pb-0'>
            <Row>
              <Col xs='9'>
                <H5>{SkillStatus}</H5>
              </Col>
              <Col xs='3' className='text-end'>
                <FiTrendingUp style={{ width: '20px', height: '20px' }} className='text-muted' />
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <div className='chart-container'>
              <div id='circlechart'>
                <ReactApexChart options={radialChartLive.options} series={radialChartLive.series} height='370' type='radialBar' />
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};
export default SkillStatusChart;
